module.exports = __webpack_public_path__ + "static/media/marketing.01e5ef03.png";